import { createRefPath } from "global/firestoreData/appData/appRefPaths";
import { useCallback, useContext, useEffect, useState } from "react";
import { DatabaseContext } from "../DatabaseContext";
import { PapsContext } from "../PapsContext";
import { _showAppLogs, LogContext } from "../LogContext";
import { useDatabaseFns } from "./useDatabaseFns";

export const _cacheGroupTypes = {
  appUsersInfo: 'appUsersInfo',
  baseSettingsApp: 'baseSettingsApp',
  clientInfo: 'clientInfo',
  eventInfo: 'eventInfo',
  homeInfo: 'homeInfo',
  notificationInfo: 'notificationInfo',
  organizationInfo: 'organizationInfo',
  settings: 'settings',
  sportsSeasonResultsInfo: 'sportsSeasonResultsInfo',
  sportsSeasonInfo: 'sportsSeasonInfo',
  urls: 'urls',
  ts: 'ts',
}

export const useTimestamp = ({ tsType }) => {

  // logContext
  const logContext = useContext(LogContext)
  const { log_handlers } = logContext ?? {}

  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext ?? {}
  const { pathViews } = paps_state ?? {}

  const databaseContext = useContext(DatabaseContext);
  const { database_state, database_fns } = databaseContext ?? {};
  // const { fsdb, appUserDbAccess, useProdDb } = database_state;

  // const _database_fns = useDatabaseFns({ fsdb, useProdDb, appUserDbAccess })

  // console.log('database_fns', database_fns)
  // console.log('_database_fns', _database_fns)

  const [timestampInfo, setTimestampInfo] = useState({ timestamps: null, timestampsFetched: false })

  useEffect(() => {
    // this callback will trigger if the 'ts' document in firebase changes.
    const cb = (timestamps) => {
      _showAppLogs.timestamps && log_handlers.addLog(`🌐🕒 Fetched timestamps (${tsType}) data from Firebase`);
      // console.log('timestamps 1', timestamps)
      setTimestampInfo({
        timestamps,
        timestampsFetched: true
      })
    }

    const opts = { ignoreId: true, returnFirstObject: true, listen: true };

    switch (tsType) {
      case _cacheGroupTypes.ts:
        const refPath_ts = createRefPath(['_timeStamps', 'ts']);
        database_fns.get_data({ refPath: refPath_ts, opts, callback: cb });
        break;
      default:
      // nothing
    }
  }, []);

  const updateTimestamp = useCallback(async (tsType, tsKey, ts) => {
    database_fns.update_timestamp(tsType, tsKey, ts)
  }, [])

  return { timestampInfo, pathViews, updateTimestamp };

}; 